import clsx from 'clsx';
import { useStyles } from './utils';

export default function TessellManagedCloudWithCircleIcon(props = {}) {
    const { className } = props;
    const iconStyle = useStyles(props);

    return (
        <svg
            className={clsx({ [className]: !!className })}
            style={iconStyle}
            xmlns="http://www.w3.org/2000/svg"
            width="123"
            height="48"
            fill="none"
            viewBox="0 0 123 48"
        >
            <rect width="47.5" height="47.5" x="75.25" y="0.25" fill="#fff" rx="23.75" />
            <rect
                width="47.5"
                height="47.5"
                x="75.25"
                y="0.25"
                stroke="#CCC"
                strokeWidth="0.5"
                rx="23.75"
            />
            <g clipPath="url(#clip0_2307_498)">
                <path
                    fill="#EA4335"
                    d="M103.296 19.292l2.263-2.268.151-.956c-4.123-3.758-10.678-3.332-14.395.89a10.495 10.495 0 00-2.207 4.144l.81-.114 4.526-.749.35-.358c2.012-2.216 5.416-2.514 7.74-.629l.762.04z"
                />
                <path
                    fill="#4285F4"
                    d="M108.783 21.035a10.228 10.228 0 00-3.073-4.966l-3.176 3.183a5.664 5.664 0 012.072 4.49v.565a2.83 2.83 0 012.827 2.833c0 1.565-1.266 2.802-2.827 2.802h-5.66l-.556.605v3.399l.555.533h5.661a7.333 7.333 0 007.409-7.28 7.377 7.377 0 00-3.232-6.164z"
                />
                <path
                    fill="#34A853"
                    d="M93.293 34.48h5.653v-4.538h-5.653a2.77 2.77 0 01-1.16-.255l-.801.247-2.279 2.269-.198.772a7.324 7.324 0 004.438 1.504z"
                />
                <path
                    fill="#FBBC05"
                    d="M93.293 19.762c-4.06.024-7.333 3.344-7.309 7.414a7.377 7.377 0 002.87 5.799l3.28-3.288a2.836 2.836 0 01-1.413-3.749 2.824 2.824 0 015.152 0l3.279-3.287a7.337 7.337 0 00-5.86-2.89z"
                />
            </g>
            <rect width="47.5" height="47.5" x="50.25" y="0.25" fill="#fff" rx="23.75" />
            <rect
                width="47.5"
                height="47.5"
                x="50.25"
                y="0.25"
                stroke="#CCC"
                strokeWidth="0.5"
                rx="23.75"
            />
            <g clipPath="url(#clip1_2307_498)">
                <path
                    fill="#252F3E"
                    d="M66.81 23.991c0 .378.041.684.113.908.081.224.183.469.326.734a.443.443 0 01.072.235c0 .102-.062.204-.194.306l-.643.428a.49.49 0 01-.265.092c-.102 0-.204-.051-.306-.143a3.16 3.16 0 01-.367-.48 7.894 7.894 0 01-.316-.601c-.795.938-1.795 1.407-2.998 1.407-.856 0-1.54-.244-2.04-.734s-.754-1.142-.754-1.958c0-.867.306-1.57.928-2.1.622-.53 1.448-.796 2.498-.796.347 0 .704.03 1.081.082.378.05.765.132 1.173.224v-.744c0-.775-.163-1.316-.48-1.632-.326-.316-.876-.469-1.662-.469-.356 0-.724.04-1.1.133a8.143 8.143 0 00-1.102.346 2.92 2.92 0 01-.357.133.624.624 0 01-.163.03c-.143 0-.214-.102-.214-.316v-.5c0-.163.02-.285.071-.356a.764.764 0 01.286-.214 5.87 5.87 0 011.284-.46 6.18 6.18 0 011.591-.193c1.214 0 2.1.275 2.672.826.56.55.846 1.387.846 2.509v3.303h.02zm-4.14 1.55c.337 0 .684-.06 1.05-.183.368-.123.694-.347.97-.653.163-.193.285-.408.346-.652a3.66 3.66 0 00.102-.888v-.428a8.513 8.513 0 00-.938-.173 7.684 7.684 0 00-.958-.061c-.684 0-1.183.132-1.52.407-.336.276-.5.663-.5 1.173 0 .48.123.836.378 1.081.245.255.602.377 1.07.377zm8.189 1.102c-.183 0-.306-.03-.387-.102-.082-.061-.153-.204-.215-.398l-2.396-7.883c-.061-.204-.092-.336-.092-.407 0-.164.082-.255.245-.255h1c.193 0 .326.03.397.102.082.06.143.204.204.397l1.713 6.751 1.59-6.75c.052-.205.113-.337.195-.398.081-.062.224-.102.408-.102h.815c.194 0 .327.03.408.102.082.06.153.204.194.397l1.611 6.833 1.764-6.833c.061-.204.133-.336.204-.397.082-.062.214-.102.398-.102h.948c.163 0 .255.081.255.255 0 .05-.01.102-.02.163-.01.06-.03.143-.072.255l-2.457 7.882c-.061.204-.133.337-.214.398-.082.061-.214.102-.388.102h-.877c-.194 0-.326-.03-.408-.102-.081-.071-.153-.204-.193-.408l-1.58-6.577-1.571 6.567c-.051.204-.112.336-.194.408-.082.071-.224.102-.408.102h-.877zm13.104.275c-.53 0-1.06-.061-1.57-.183-.51-.123-.908-.255-1.173-.408-.164-.092-.276-.194-.317-.286a.722.722 0 01-.06-.285v-.52c0-.215.08-.317.234-.317.061 0 .122.01.183.031.061.02.153.061.255.102.347.153.724.275 1.122.357.408.081.806.122 1.213.122.643 0 1.143-.112 1.49-.336.346-.225.53-.551.53-.97a.993.993 0 00-.276-.713c-.183-.194-.53-.367-1.03-.53l-1.478-.459c-.745-.235-1.295-.581-1.632-1.04a2.43 2.43 0 01-.51-1.479c0-.428.092-.805.276-1.132.183-.326.428-.611.734-.836a3.235 3.235 0 011.06-.53 4.444 4.444 0 011.285-.174c.224 0 .46.01.683.041.235.03.45.072.663.112.204.052.398.102.582.164.183.06.326.122.428.183a.882.882 0 01.306.255.55.55 0 01.091.337v.479c0 .214-.081.326-.234.326-.082 0-.214-.04-.388-.122-.58-.265-1.234-.398-1.958-.398-.58 0-1.04.092-1.356.286-.316.193-.479.49-.479.907 0 .286.102.53.306.724.204.194.581.388 1.122.561l1.448.459c.734.235 1.264.56 1.58.979.316.418.47.897.47 1.428 0 .438-.092.836-.266 1.182a2.743 2.743 0 01-.744.898 3.286 3.286 0 01-1.132.57 4.848 4.848 0 01-1.458.215z"
                />
                <path
                    fill="#F90"
                    fillRule="evenodd"
                    d="M85.89 31.874c-3.355 2.478-8.23 3.793-12.42 3.793-5.874 0-11.166-2.172-15.164-5.781-.316-.286-.03-.674.347-.45 4.324 2.51 9.657 4.029 15.174 4.029 3.722 0 7.81-.775 11.574-2.366.56-.255 1.04.367.49.775z"
                    clipRule="evenodd"
                />
                <path
                    fill="#F90"
                    fillRule="evenodd"
                    d="M87.287 30.283c-.428-.55-2.835-.265-3.926-.132-.326.04-.377-.245-.081-.46 1.917-1.345 5.068-.958 5.435-.51.367.46-.102 3.61-1.897 5.12-.275.234-.54.112-.418-.194.408-1.01 1.315-3.283.887-3.824z"
                    clipRule="evenodd"
                />
            </g>
            <rect width="47.5" height="47.5" x="25.25" y="0.25" fill="#fff" rx="23.75" />
            <rect
                width="47.5"
                height="47.5"
                x="25.25"
                y="0.25"
                stroke="#CCC"
                strokeWidth="0.5"
                rx="23.75"
            />
            <path
                fill="url(#paint0_linear_2307_498)"
                d="M44.742 11H52.5l-8.054 23.865a1.237 1.237 0 01-1.173.842h-6.038a1.236 1.236 0 01-1.17-1.63l7.503-22.235A1.237 1.237 0 0144.742 11z"
            />
            <path
                fill="#0078D4"
                d="M56.016 27.007H43.712a.57.57 0 00-.388.986l7.906 7.38c.23.214.533.334.848.334h6.967l-3.029-8.7z"
            />
            <path
                fill="url(#paint1_linear_2307_498)"
                d="M44.742 11a1.226 1.226 0 00-1.175.858l-7.493 22.198a1.234 1.234 0 001.165 1.65h6.194a1.324 1.324 0 001.017-.864l1.493-4.403 5.338 4.978c.223.185.504.287.794.29h6.941l-3.044-8.7-8.875.002L52.53 11h-7.787z"
            />
            <path
                fill="url(#paint2_linear_2307_498)"
                d="M54.653 11.84a1.235 1.235 0 00-1.17-.84h-8.648a1.236 1.236 0 011.17.84l7.505 22.236a1.236 1.236 0 01-1.17 1.63h8.647a1.234 1.234 0 001.17-1.63L54.653 11.84z"
            />
            <rect width="47.5" height="47.5" x="0.25" y="0.25" fill="#fff" rx="23.75" />
            <rect
                width="47.5"
                height="47.5"
                x="0.25"
                y="0.25"
                stroke="#CCC"
                strokeWidth="0.5"
                rx="23.75"
            />
            <path
                fill="#29B5E8"
                fillRule="evenodd"
                d="M32.278 29.117l-8.007-4.635 7.996-4.616 3.837 2.273.172 4.67-3.998 2.308zM23.736 14.246l-.011 9.252-7.996-4.616.05-4.46 3.96-2.484 3.997 2.308zM15.25 29.577l8.018-4.616v9.232l-3.887 2.187-4.13-2.187v-4.616z"
                clipRule="evenodd"
            />
            <path
                fill="#11567F"
                fillRule="evenodd"
                d="M24.252 33.754l.01-9.252 7.996 4.616-.05 4.46-3.958 2.484-3.998-2.308zM15.722 18.914l8.007 4.636-7.996 4.616-3.837-2.273-.171-4.67 3.997-2.309zM31.776 18.95l-8.017 4.616v-9.233l3.887-2.187 4.13 2.187v4.616z"
                clipRule="evenodd"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_2307_498"
                    x1="47.57"
                    x2="39.512"
                    y1="12.831"
                    y2="36.636"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#114A8B" />
                    <stop offset="1" stopColor="#0669BC" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_2307_498"
                    x1="50.087"
                    x2="48.223"
                    y1="23.925"
                    y2="24.555"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopOpacity="0.3" />
                    <stop offset="0.071" stopOpacity="0.2" />
                    <stop offset="0.321" stopOpacity="0.1" />
                    <stop offset="0.623" stopOpacity="0.05" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_2307_498"
                    x1="49.063"
                    x2="57.908"
                    y1="12.136"
                    y2="35.702"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#3CCBF4" />
                    <stop offset="1" stopColor="#2892DF" />
                </linearGradient>
                <clipPath id="clip0_2307_498">
                    <path fill="#fff" d="M0 0H26.031V21H0z" transform="translate(85.984 13.5)" />
                </clipPath>
                <clipPath id="clip1_2307_498">
                    <path fill="#fff" d="M0 0H34V34H0z" transform="translate(58 7)" />
                </clipPath>
            </defs>
        </svg>
    );
}
